import {Axios} from '../axios/axios.js'
//group list
export const getGroupList = (e) => {
  return Axios({
    url:"/index.php/driver_group/get_driver_group_list",
    method:'put',
    data:e
  })
}
//group add
export const addGroup = (e) => {
  return Axios({
    url:"/index.php/driver_group/add_driver_group",
    method:'put',
    data:e
  })
}
//编辑 group
export const editGroup = (e) => {
  return Axios({
    url:'/index.php/driver_group/edit_driver_group',
    method:"put",
    data:e
  })
}
//删除 group
export const deleteGroup = (e) => {
  return Axios({
    url:'/index.php/driver_group/del_driver_group',
    method:"put",
    data:e
  })
}
//dirvers list
export const getDriversList = (e) => {
  return Axios({
    url:'/index.php/driver_group/get_group_worker_list',
    method:"put",
    data:e
  })
}
//add drivers
export const addDrivers = (e) => {
  return Axios({
    url:'/index.php/driver_group/add_group_worker',
    method:"put",
    data:e
  })
}
//删除 drivers
export const deleteDrivers = (e) => {
  return Axios({
    url:'/index.php/driver_group/del_group_worker',
    method:"put",
    data:e
  })
}
//编辑 driver
export const editDrivers = (e) => {
  return Axios({
    url:'/index.php/driver_group/edit_group_worker',
    method:"put",
    data:e
  })
}
//刷新司机
export const refreshDriver = (e) => {
  return Axios({
    url:'/DriverGroup/synchronous_data',
    method:"put",
    data:e
  })
}
//分组司机列表 /index.php/driver_group/get_worker_tag
export const workerTagList = (e) => {
  return Axios({
    url:'/index.php/driver_group/get_worker_tag',
    method:"put",
    data:e
  })
}

//司机分组列表 统计图适用
export const workerTagList2 = (e) => {
  return Axios({
    url:'/index.php/anylaze/get_worker_tag',
    method:"put",
    data:e
  })
}


//分组司机标签新增

export const workerTagAdd = (e) => {
  return Axios({
    url:'/index.php/driver_group/add_worker_tag',
    method:"put",
    data:e
  })
}
//分组司机标签编辑
export const workerTagEdit = (e) => {
  return Axios({
    url:'/index.php/driver_group/edit_worker_tag',
    method:"put",
    data:e
  })
}
//分组司机标签删除
export const workerTagDelete = (e) => {
  return Axios({
    url:'/index.php/driver_group/del_worker_tag',
    method:"put",
    data:e
  })
}
//修改司机active状态 change_drivers_status
export const changeDriverActive = (e) => {
  return Axios({
    url:'index.php/DriverGroup/change_drivers_status',
    method:"put",
    data:e
  })
}
//修改司机密码 worker/reset_password
export const resetDriverPas = (e) => {
  return Axios({
    url:'index.php/worker/reset_password',
    method:"put",
    data:e
  })
}

// 打印司机的code  输出pdf
export const printWorkerPDF = (e) => {
  return Axios({
    url:'index.php/DriverGroup/print_worker',
    method:"put",
    data:e
  })
}
